import React, { Component } from "react"
import moment from "moment"
//sass
import "../../sass/BidsPage/_bids-page.scss"
//func
import { getBids } from "../../functions/api/orders"
//comps
import Popup from "../Header/Parts/Popup/Popup"
import Loader from "../LoaderNew/Loader"
//
import { connect } from "react-redux"
import * as actions from "../../actions/actions"
import DropDownBox from "../Header/Parts/Popup/Parts/DropDownBox/DropDownBox"
import { updateClient } from "../../functions/api/popup"
import ErrorPopup from "../NavBar/ErrorPopup/ErrorPopup"
import Arrow_1 from '../../images/general/arrow_1.svg'
import Arrow_2 from '../../images/general/arrow_2.svg'
import SideBar from "../SideBar/SideBar"

import {
  getOrders,
  getOrdersCount,
  getWarnings,
  upateOrders,
  repositionForConst,
  setEndDateForProcess
} from "../../functions/api/orders"
import { findRangOfDatesFromWeeksArr } from "../../functions/data/weeks_generator"
import { getClientDateForPopup } from "../../functions/api/popup";

import OnDragPopup from "../updatePopups/OnDragPopup"
import ReasonPopup from "../updatePopups/ReasonPopup"
import SpreadingPopup from "../updatePopups/SpreadingPopup"
import ConstantPopup from "../updatePopups/ConstantPopup"
import QuotesTablePage from "../CustomersPage/Quote/QuotesTablePage"
import {
  convertIntoCurrency,
  getAllExtraCharges,
  getAmountIncludingExtraCharges,
  setNavigationUrl
} from "../../hooks/helper"
import { Typography, TablePagination } from "@material-ui/core"


class BidsPage extends Component {
  constructor() {
    super()

    this.state = {
      tabName: 'prevQuotes',
      // ===== PAGINATION STATE =====
      page: 0,            // page INDEX (0-based)
      rowsPerPage: 20,    // rows per page
      totalCount: 0,      // total rows from API
      // ============================
      order: 1,
      sort: "due_date",
      popup: false,
      loader: true,
      selectedBid: {},
      orders: [],
      status_input_options: [
        { name: "הצעה", _id: false },
        { name: "הזמנה", _id: true },
        { name: "בוטלה", _id: false }
      ],
      error_text: "",
      show_error_popup: false,
      customField: false,
      //update from popup
      draggable_process_for_popup: {},
      reposition_body: {},
      order_befor_reposition: {},
      warning_message: "",
      warnings: [],
      spread: false,
      body_for_new_end_date: false,
      error_update_popup: false,
    }
  }

  // ==========================================
  // LIFECYCLE
  // ==========================================

  async componentDidMount() {
    const pathname = window.location.pathname;
    this.props.setRouteLocation(pathname);
    this.fetchBids();
  }

  componentDidUpdate(prevProps) {
    const prevDueDate =
      prevProps.mainPopup.new_due_date_after_edit_from_reservation_popup;
    const nextDueDate =
      this.props.mainPopup.new_due_date_after_edit_from_reservation_popup;

    const nextUpdateOrder =
      this.props.mainPopup.order_after_edit_from_reservation_popup || {};

    // reposition logic
    if (!nextUpdateOrder.cancelled) {
      if (prevDueDate !== nextDueDate && nextDueDate && nextDueDate.length > 0) {
        this.repositionAfterEditInPopup(nextDueDate);
      }
    }

    // popup closed -> refresh current page
    if (prevProps.mainPopup.show_popup && !this.props.mainPopup.show_popup) {
      this.fetchBids();
    }
  }

  // ==========================================
  // DATA FETCHING (PAGINATION)
  // ==========================================

  fetchBids = async () => {
    const { page, rowsPerPage, order, sort } = this.state;

    this.setState({ loader: true });

    try {
      const skip = page * rowsPerPage;
      const res = await getBids(skip, rowsPerPage, order, sort);
      const { ok, result, count } = res || {};

      if (ok) {
        this.setState(
          {
            orders: result || [],
            totalCount: count || 0,
            loader: false
          },
          () => {
            this.setCustomField(this.state.orders);
          }
        );
      } else {
        this.setState({
          orders: [],
          totalCount: 0,
          loader: false
        });
      }
    } catch (error) {
      console.error("Bids fetch failed", error);
      this.setState({
        orders: [],
        totalCount: 0,
        loader: false
      });
    }
  };

  // ==========================================
  // PAGINATION HANDLERS
  // ==========================================

  handleChangePage = (event, newPage) => {
    this.setState(
      { page: newPage },
      () => {
        this.fetchBids();
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      () => {
        this.fetchBids();
      }
    );
  };

  // ==========================================
  // HELPERS
  // ==========================================

  setCustomField = (orders = []) => {
    const itemWithCustomField = orders.find(item => item.custom_column_name);
    this.setState({
      customField: itemWithCustomField
        ? itemWithCustomField.custom_column_name
        : false
    });
  };

  // ==========================================
  // SORTING
  // ==========================================

  sortBy = (sort_by) => {
    const { sort } = this.state;

    if (sort === sort_by) {
      // same column -> toggle order
      this.setState(
        prevState => ({
          page: 0,
          order: prevState.order === 1 ? -1 : 1
        }),
        () => {
          this.fetchBids();
        }
      );
      return;
    }

    this.setState(
      {
        page: 0,
        sort: sort_by,
        order: 1
      },
      () => {
        this.fetchBids();
      }
    );
  };

  // ==========================================
  // UPDATE POPUP HANDLERS
  // ==========================================

  updateWarningMessage = warning_message => {
    this.setState({ warning_message });
  }

  updateWarningsArray = warnings_array => {
    this.setState({ warnings: warnings_array });
  }

  updateStateForWarningPopup = (
    draggable_process_for_popup_obj,
    reposition_body,
    order_data_prev_copy
  ) => {
    this.setState({
      draggable_process_for_popup: draggable_process_for_popup_obj,
      reposition_body: reposition_body,
      order_befor_reposition: order_data_prev_copy
    });
  }

  updateErrorPopup = boolean => {
    this.setState({ error_update_popup: boolean });
  }

  popupActionHandler = async (yes_no, constantData = false) => {
    let {
      reposition_body,
      draggable_process_for_popup,
      spread,
      body_for_new_end_date
    } = this.state;

    this.props.updateWarningPopup(false);

    if (yes_no === "no") {
      return;
    }

    this.props.upadteLoaderPopup(true);

    if (constantData) {
      reposition_body.reason = constantData.reason.value;
      reposition_body.approved_by = constantData.approveName.value;

      let get_warnings;

      if (spread) {
        get_warnings = await getWarnings(reposition_body, true);
      } else {
        get_warnings = await getWarnings(reposition_body);
      }

      if (!get_warnings.ok) {
        this.updateWarningMessage(get_warnings.result);
        this.updateWarningsArray([]);
      } else {
        this.updateWarningMessage("");
        this.updateWarningsArray(get_warnings.result);
      }

      if (get_warnings.result.length > 0) {
        this.props.upadteLoaderPopup(false);
        this.props.updateWarningPopup(true);
        return;
      }
    }

    let order_reposition;

    if (draggable_process_for_popup.process.constant) {
      order_reposition = await repositionForConst(reposition_body);
    } else {
      if (spread) {
        order_reposition = await upateOrders(reposition_body, true);
        this.setState({ spread: false });
      } else {
        order_reposition = await upateOrders(reposition_body);
      }
    }

    if (!order_reposition.ok) {
      this.props.upadteLoaderPopup(false);
      this.setState(
        { warning_message: order_reposition.result },
        () => {
          this.updateErrorPopup(true);
        }
      );

      if (body_for_new_end_date) {
        let res = await setEndDateForProcess(body_for_new_end_date);
        if (!res.ok) {
          this.updateWarningMessage(res.result);
          this.updateErrorPopup(true);
        }
        this.setState({ body_for_new_end_date: false });
      }
      return;
    }

    this.props.upadteLoaderPopup(false);
    this.fetchBids();

    if (body_for_new_end_date) {
      let res = await setEndDateForProcess(body_for_new_end_date);
      if (!res.ok) {
        this.updateWarningMessage(res.result);
        this.updateErrorPopup(true);
      }
      this.setState({ body_for_new_end_date: false });
    }
  }

  handleSpreadWithReason = async reason_and_approveName => {
    let { reposition_body, spread } = this.state;

    this.props.updateReasonePopUp(false);
    this.props.upadteLoaderPopup(true);
    reposition_body.reason = reason_and_approveName.reason.value;
    reposition_body.approved_by = reason_and_approveName.approveName.value;

    let get_warnings = await getWarnings(reposition_body, true);
    if (!get_warnings.ok) {
      this.updateWarningMessage(get_warnings.result);
      this.updateWarningsArray([]);
    } else {
      this.updateWarningMessage("");
      this.updateWarningsArray(get_warnings.result);
    }

    if (get_warnings.result.length === 0) {
      let order_reposition_res = await upateOrders(reposition_body, true);

      if (!order_reposition_res.ok) {
        this.props.upadteLoaderPopup(false);
        this.setState(
          { warning_message: order_reposition_res.result },
          () => {
            this.updateErrorPopup(true);
          }
        );
      } else {
        this.props.upadteLoaderPopup(false);
        this.fetchBids();
      }

      this.setState({ spread: false });
    } else {
      this.props.upadteLoaderPopup(false);
      this.props.updateWarningPopup(true);
    }

    if (reposition_body.endDate) {
      let new_body = {
        _id: reposition_body._id,
        date: reposition_body.endDate
      };
      let res = await setEndDateForProcess(new_body);
      if (!res.ok) {
        this.updateWarningMessage(res.result);
        this.updateErrorPopup(true);
      }
    }
  }

  worningAndReposition = async () => {
    let { reposition_body, spread } = this.state;

    this.props.updateSpreadPopup(false);

    let get_warnings;

    if (spread) {
      get_warnings = await getWarnings(reposition_body, true);
    } else {
      get_warnings = await getWarnings(reposition_body);
    }

    if (!get_warnings.ok) {
      this.updateWarningMessage(get_warnings.result);
      this.updateWarningsArray([]);
      this.props.upadteLoaderPopup(true);
    } else {
      this.updateWarningMessage("");
      this.updateWarningsArray(get_warnings.result);
    }

    this.props.upadteLoaderPopup(true);
    let order_reposition;

    if (get_warnings.result.length === 0) {
      if (spread) {
        order_reposition = await upateOrders(reposition_body, true);
        this.setState({ spread: false });
      } else {
        order_reposition = await upateOrders(reposition_body);
      }

      if (!order_reposition.ok) {
        this.props.upadteLoaderPopup(false);
        this.setState(
          { warning_message: order_reposition.result },
          () => {
            this.updateErrorPopup(true);
          }
        );
        return;
      } else {
        this.props.upadteLoaderPopup(false);
        this.fetchBids();
      }
    } else {
      this.props.upadteLoaderPopup(false);
      this.props.updateWarningPopup(true);
      return;
    }

    if (reposition_body.endDate) {
      let new_body = {
        _id: reposition_body._id,
        date: reposition_body.endDate
      };
      let res = await setEndDateForProcess(new_body);
      if (!res.ok) {
        this.updateWarningMessage(res.result);
        this.updateErrorPopup(true);
      }
    }
  }

  repositionAfterEditInPopup = async (update_order) => {
    const { mainPopup } = this.props;

    let order_data_for_popup = await getClientDateForPopup(mainPopup.order_id);
    let order_data_from_api;

    if (order_data_for_popup.ok) {
      order_data_from_api = order_data_for_popup.result;
    } else {
      return;
    }

    let last_process_id = order_data_from_api.last_process;
    let findLastProcessForReposition = order_data_from_api.last_order_process[0];

    if (!moment(mainPopup.order_data.due_date).isSame(moment(update_order))) {
      let oldDate = moment(mainPopup.order_data.due_date);
      var newDate = moment(update_order);

      if (newDate > oldDate) {
        this.props.isGreaterDate(true);
      } else {
        this.props.isGreaterDate(false);
      }

      let order_data_prev_copy_state = JSON.parse(
        JSON.stringify(findLastProcessForReposition)
      );
      let process_obj_state = { process: findLastProcessForReposition };

      let body = {
        order_id: mainPopup.order_id,
        _id: last_process_id,
        date: update_order,
        view: "L",
        from: moment().format(),
        to: moment().add(10, 'days').format()
      };

      this.updateStateForWarningPopup(
        process_obj_state,
        body,
        order_data_prev_copy_state
      );

      if (findLastProcessForReposition.is_detached) {
        let get_warnings = await getWarnings(body);
        if (!get_warnings.ok) {
          this.updateWarningMessage(get_warnings.result);
          this.updateWarningsArray([]);
        } else {
          this.updateWarningMessage("");
          this.updateWarningsArray(get_warnings.result);
        }

        this.props.upadteLoaderPopup(true);

        if (get_warnings.result.length === 0) {
          let order_reposition = await upateOrders(body);
          this.props.upadteLoaderPopup(false);

          if (!order_reposition.ok) {
            alert("לא ניתן להזיז את התהליך שבחרת");
            return;
          } else {
            this.fetchBids();
          }
        } else {
          this.props.upadteLoaderPopup(false);
          this.props.updateWarningPopup(true);
          return;
        }
      } else {
        if (findLastProcessForReposition.constant) {
          this.updateWarningMessage("");
          this.props.updateConstantPopup(true);
        } else {
          this.updateWarningMessage("");
          this.props.updateSpreadPopup(true);
        }
      }
    }
  }

  // ==========================================
  // ORDER STATUS / SELECTION
  // ==========================================

  setSelectedBid = (e, selectedBid) => {
    e.stopPropagation();
    this.props.setOrderDataForPopup(selectedBid);
    this.props.setOrderIdForPopup(selectedBid._id);
    this.props.showMainPopup(true);
  }

  formatNumber = num => {
    if (num % 1 !== 0) num = num.toFixed(2);
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  statusDropDownOptions = status => {
    const { status_input_options } = this.state;
    let status_input_options_copy = JSON.parse(
      JSON.stringify(status_input_options)
    );

    if (status.started) {
      return status_input_options_copy.filter(i => i.name !== "הזמנה");
    } else {
      return status_input_options_copy.filter(i => i.name !== "הצעה");
    }
  }

  updateOrder = async (name, option) => {
    this.props.upadteLoaderPopup(true);
    const { selectedBid } = this.state;
    let copy_selectedBid = JSON.parse(JSON.stringify(selectedBid));

    let body = {
      _id: copy_selectedBid._id,
      [name]: option,
      client_name: copy_selectedBid.client_name,
      client_phone: copy_selectedBid.client_phone,
      client_email: copy_selectedBid.client_email,
      employees: copy_selectedBid.employees,
      collection_stages: copy_selectedBid.collection_stages,
      quantity: copy_selectedBid.quantity,
      value: copy_selectedBid.value,
      due_date: copy_selectedBid.due_date,
      order_number: copy_selectedBid.order_number
    };

    let res = await updateClient(body);
    if (res.ok) {
      this.updateOrdersAfterUpdate(res.result);
    } else {
      this.setState(
        { error_text: res.result },
        () => {
          this.showErorrPopup(true);
          this.updateOrdersAfterUpdate(selectedBid);
        }
      );
    }
  }

  updateOrdersAfterUpdate = update_order => {
    const { orders } = this.state;

    if (update_order.started || update_order.cancelled) {
      let new_orders = orders.filter(o => o._id !== update_order._id);
      this.setState({
        orders: new_orders,
        selectedBid: {},
        totalCount: this.state.totalCount - 1
      });
    }

    this.props.upadteLoaderPopup(false);
  }

  saveSelectedOrder = selectedBid => {
    this.setState({ selectedBid });
    this.redirectToQuotePage(selectedBid);
  }

  redirectToQuotePage = (selectedBid) => {
    const { customer_id, _id } = selectedBid;
    const factoryName = this.props.login.user.factory_name;
    if (customer_id && _id) {
      setNavigationUrl(`${this.props.history.location.pathname}`);
      this.props.history.push(
        `/${factoryName}/customers-page/create-quote/${customer_id}/${_id}`
      );
    }
  }

  showErorrPopup = boolean => {
    this.setState({ showErorrPopup: boolean });
  }

  cancleSpreading = () => {
    this.props.updateSpreadPopup(false);
    this.props.updateConstantPopup(false);
  }

  closeReasonPopup = () => {
    this.props.updateReasonePopUp(false);
  }

  spreadingTrue = () => {
    this.props.updateSpreadPopup(false);

    this.setState(
      { spread: true },
      () => {
        if (this.props.orders.is_greater_date) {
          this.props.updateReasonePopUp(true);
        } else {
          this.worningAndReposition();
        }
      }
    );
  }

  switchTabs = (tabValue = 'prevQuotes') => {
    this.props.setCurrentBidsPage(tabValue);
  }

  // ==========================================
  // RENDER
  // ==========================================

  render() {
    const {
      orders,
      order,
      sort,
      loader,
      error_text,
      show_error_popup,
      customField,
      draggable_process_for_popup,
      warning_message,
      warnings,
      error_update_popup,
      // pagination
      page,
      rowsPerPage,
      totalCount
    } = this.state;

    let { currentBidsPageName } = this.props.quotationManagement;

    return (
      <div className="bids__page__container">
        <SideBar />
        <div className="bids-page">

          {/* ===== TABS ===== */}
          <div className="bids-tabs">
            <header>
              <span>
                <Typography
                  variant='h5'
                  className={`bids-tabs-heading ${currentBidsPageName === 'prevQuotes' ? 'active-tab-text' : ''}`}
                  onClick={() => this.switchTabs('prevQuotes')}
                >{'הצעות מחיר'}</Typography>
                <Typography
                  variant='h5'
                  className={`bids-tabs-heading ${currentBidsPageName === 'newQuotes' ? 'active-tab-text' : ''}`}
                  onClick={() => this.switchTabs('newQuotes')}
                  style={{ marginRight: '2%' }}
                >{'הצעת מחיר'}</Typography>
              </span>
            </header>
          </div>

          {/* ===== PREV QUOTES TAB ===== */}
          <div className={`bids-tabs-prev ${currentBidsPageName === 'prevQuotes' ? 'active-tab' : 'inactive-tab'}`}>

            {/* TABLE HEADER */}
            <header>
              <div
                style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}
                onClick={() => this.sortBy("order_number")}
              >
                מספר הצעה {sort === "order_number" ?
                  <img className="sort__arrow__icon" src={order === -1 ? Arrow_1 : Arrow_2} alt="arrow" /> : null}
              </div>
              <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                שם לקוח
              </div>
              <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                נייד
              </div>
              <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                מייל
              </div>
              <div
                style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}
                onClick={() => this.sortBy("total")}
              >
                ערך עסקה {sort === "total" ?
                  <img className="sort__arrow__icon" src={order === -1 ? Arrow_1 : Arrow_2} alt="arrow" /> : null}
              </div>
              {customField ?
                <div
                  style={{ width: `calc(100% / 8)` }}
                  onClick={() => this.sortBy("custom_column_date")}
                >
                  {customField} {sort === "custom_column_date" ?
                    <img className="sort__arrow__icon" src={order === -1 ? Arrow_1 : Arrow_2} alt="arrow" /> : null}
                </div> : null}
              <div
                style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}
                onClick={() => this.sortBy("created_at")}
              >
                תאריך פתיחת הצעה {sort === "created_at" ?
                  <img className="sort__arrow__icon" src={order === -1 ? Arrow_1 : Arrow_2} alt="arrow" /> : null}
              </div>
              <div
                style={customField
                  ? { width: `calc(100% / 8)`, cursor: 'pointer' }
                  : { width: `calc(100% / 7)`, cursor: 'pointer' }}
                onClick={() => this.sortBy("due_date")}
              >
                תאריך אספקה {sort === "due_date" ?
                  <img className="sort__arrow__icon" src={order === -1 ? Arrow_1 : Arrow_2} alt="arrow" /> : null}
              </div>
              <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                סטטוס
              </div>
            </header>

            {/* TABLE BODY */}
            <div className="bids-page__orders">
              {loader ? (
                <div className="bids-loader">
                  <Loader />
                </div>
              ) : orders && orders.length > 0 ? (
                orders.map(item => (
                  <div
                    key={item._id}
                    className="bids-page__orders__bid"
                    onClick={() => this.saveSelectedOrder(item)}
                  >
                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {item.order_number}
                    </div>
                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {item.client_name}
                    </div>
                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {item.client_phone}
                    </div>
                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {item.client_email}
                    </div>
                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {convertIntoCurrency(
                        getAmountIncludingExtraCharges(
                          Number(
                            Number(item.value) +
                            Number(getAllExtraCharges(item.extra_charges || []) || 0) || 0
                          ),
                          item.order_discount
                        ),
                        'ILS'
                      )}
                    </div>

                    {customField ?
                      <div style={{ width: `calc(100% / 8)` }}>
                        {item.custom_column_date
                          ? moment(item.custom_column_date).format("DD/MM/YYYY")
                          : null}
                      </div> : null}

                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {moment(item.created_at).format("DD/MM/YYYY")}
                    </div>
                    <div style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}>
                      {moment(item.due_date).format("DD/MM/YYYY")}
                    </div>
                    <div
                      style={customField ? { width: `calc(100% / 8)` } : { width: `calc(100% / 7)` }}
                      onClick={e => e.stopPropagation()}
                    >
                      <DropDownBox
                        key={item._id}
                        validate_all_form={false}
                        title={false}
                        data={this.statusDropDownOptions(item)}
                        updateForm={this.updateOrder}
                        name={"started"}
                        validate_message={"יש לבחור סטטוס"}
                        selected_step={item.started ? "הזמנה" : "הצעה"}
                      />
                    </div>
                    <button
                      onClick={(e) => this.setSelectedBid(e, item)}
                    >
                      הצג
                    </button>
                  </div>
                ))
              ) : (
                <div className="no__bids">אין הצעות מחיר</div>
              )}
            </div>

            {/* ===== PAGINATION ===== */}
            {totalCount > 0 && (
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, 100]}
                component="div"
                colSpan={3}
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: false,
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                labelRowsPerPage="שורות לעמוד:"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} מתוך ${count !== -1 ? count : `יותר מ-${to}`}`
                }
                style={{
                  direction: 'ltr',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              />
            )}
          </div>

          {/* ===== NEW QUOTES TAB ===== */}
          {currentBidsPageName === 'newQuotes' &&
            <div className={`bids-tabs-new`}>
              <QuotesTablePage />
            </div>
          }
        </div>

        {/* ===== POPUPS ===== */}
        {show_error_popup ? (
          <ErrorPopup
            afterConfirmationError={error_text}
            updatePopup={this.showErorrPopup}
          />
        ) : null}

        {this.props.loaderPopup.loaderPopup ? <Loader /> : null}

        {this.props.orders.warningPopup ? (
          <OnDragPopup
            warningApiPayload={draggable_process_for_popup}
            popupActionHandler={this.popupActionHandler}
            afterConfirmationError={warning_message}
            warnings={warnings}
          />
        ) : null}

        {error_update_popup ? (
          <ErrorPopup
            afterConfirmationError={warning_message}
            updatePopup={this.updateErrorPopup}
          />
        ) : null}

        {this.props.orders.reason_popup ? (
          <ReasonPopup
            handleSpreadWithReason={this.handleSpreadWithReason}
            cancelPopup={() => this.closeReasonPopup()}
          />
        ) : null}

        {this.props.orders.spread_popup ? (
          <SpreadingPopup
            spreadingFalse={this.worningAndReposition}
            spreadingTrue={this.spreadingTrue}
            cancleSpreading={this.cancleSpreading}
          />
        ) : null}

        {this.props.orders.constant_popup ? (
          <ConstantPopup
            resetReposition={null}
            spreadingFalse={this.worningAndReposition}
            spreadingTrue={this.spreadingTrue}
            cancleSpreading={this.cancleSpreading}
          />
        ) : null}
      </div>
    )
  }
}

function mapStateToProps({
  router,
  route,
  orders,
  csv,
  mainPopup,
  loaderPopup,
  login,
  quotationManagement
}) {
  return { router, route, orders, csv, mainPopup, loaderPopup, login, quotationManagement }
}

export default connect(mapStateToProps, actions)(BidsPage)